import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

type Color = string;

@Pipe({
    name: 'parseLogAction',
    standalone: false
})
export class ParseLogActionPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {}

  transform(value: string, ...args: unknown[]) {
    const colors = this.colorCodedString(value);

    return colors;
  }

  // Function to generate a deterministic hash from a string
  hashString(str: string) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash |= 0; // Convert to 32bit integer
    }
    return hash;
  }
  clamp(value: number, min: number, max: number) {
    return Math.max(min, Math.min(max, value));
  }
  hashToColor(hash: number) {
    const r = (hash & 0xff0000) >> 16;
    const g = (hash & 0x00ff00) >> 8;
    const b = hash & 0x0000ff;

    // Clamp the color values to avoid very dark or very light colors
    const clampedR = this.clamp(r, 32, 220);
    const clampedG = this.clamp(g, 32, 150);
    const clampedB = this.clamp(b, 32, 150);

    return `#${((1 << 24) + (clampedR << 16) + (clampedG << 8) + clampedB)
      .toString(16)
      .slice(1)
      .toUpperCase()}` as Color;
  }
  getContrastColor(color: Color) {
    const r = parseInt(color.slice(1, 3), 16);
    const g = parseInt(color.slice(3, 5), 16);
    const b = parseInt(color.slice(5, 7), 16);

    // Calculate the relative luminance
    const luminance = 0.299 * r + 0.587 * g + 0.114 * b;

    // Return black for bright colors and white for dark colors
    return luminance > 160 ? '#000000' : '#FFFFFF';
  }

  // Function to split string and assign deterministic colors with high-visibility inverse colors
  colorCodedString(input: string) {
    const parts = input.split('.');
    const result = parts.map((part) => {
      const hash = this.hashString(part);
      const color = this.hashToColor(hash);
      const inverse = this.getContrastColor(color);
      return { part, color, inverse };
    });
    return result;
  }
}
